// @ts-nocheck
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  formatEventDate,
  formatEventTime,
} from "../../utils/eventUtils";

export default function EventPreviewSheet({ event, onClose, onToggleSave, isSaved }) {
  const location = useLocation();
  if (!event) {
    return null;
  }

  const website = event.website || event.url || "";
  const detailId = event.primaryId || event.id;
  const detailUrl = `/events/${detailId}${location.search || ""}`;
  const isGrouped = Number(event.dayCount || 1) > 1;
  return (
    <div className="event-preview">
      <div className="event-preview-content">
        <div>
          <div className="event-preview-title">{event.name}</div>
          <div className="event-preview-location">
            {event.venueName} | {event.city}, {event.state}
          </div>
          <div className="event-preview-time">
            {isGrouped
              ? `${formatEventDate(event.groupedStartDate || event.startDateTime)} - ${formatEventDate(event.groupedEndDate || event.endDateTime)}`
              : `${formatEventDate(event.startDateTime)} at ${formatEventTime(event.startDateTime)}`}
          </div>
        </div>
        <div className="chip-group event-chip-group">
          {event.games.map((game) => (
            <span key={game} className="chip small">
              {game}
            </span>
          ))}
        </div>
        <div className="event-preview-actions">
          {website ? (
            <a
              href={website}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              View Event Website
            </a>
          ) : (
            <button type="button" className="btn-primary" disabled title="Website unavailable">
              Website unavailable
            </button>
          )}
          <Link
            to={detailUrl}
            state={{ from: `/events${location.search || ""}`, groupedEvent: event }}
            className="btn-primary"
          >
            Details
          </Link>
          <button
            type="button"
            className={`btn-secondary ${isSaved ? "active" : ""}`}
            onClick={() => onToggleSave(event)}
          >
            {isSaved ? "Saved" : "Save"}
          </button>
          <button type="button" className="link-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
